import React, {
  useState,
  useRef,
  useMemo,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {
  getUserProfile,
  adminUpdateStatus,
  adminGetUsers,
  adminNoticiation,
} from "../../../config/service";
import UpdateDetails from "./UpdateDetails";
import { Button } from "react-bootstrap";
import moment from "moment";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Report from "./Report";
import { RotatingLines } from "react-loader-spinner";
import { formattedDate } from "../../../utils/function";

// headers for search functionality
const SearchHeader = ({ field, columnSearchRef, onSearch, fieldLabel, searchNonce }) => {
  const [localValue, setLocalValue] = useState(columnSearchRef.current[field] || "");

  useEffect(() => {
    setLocalValue(columnSearchRef.current[field] || "");
  }, [searchNonce, field, columnSearchRef]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    columnSearchRef.current[field] = newValue;
  };

  const handleSearch = () => {
    onSearch({ ...columnSearchRef.current });
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <span style={{ fontWeight: "bold", marginBottom: "4px" }}>{fieldLabel}</span>
      <div style={{ display: "flex" }}>
        <input
          type="text"
          value={localValue}
          placeholder="חיפוש..."
          style={field === "Id" ? { width: "80px" } : field === "Role" ? { width: "60px" } : {}}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
        />
        <button onClick={handleSearch}>🔍</button>
      </div>
    </div>
  );
};

const UserTable = () => {
  const gridRef = useRef();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [allUser, setAllUser] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [updateId, setUpdateId] = useState();
  const [updateModal, setUpdateModal] = useState(false);
  const [userdata, setuserdata] = useState();
  const [selectedValue, setSelectedValue] = useState([]);
  const [connectedUsers, setConnectedUsers] = useState([]);
  const [selectedDoctorId, setSelectDoctorId] = useState([]);
  const [selectedSecretaryId, setSelectSecretaryId] = useState([]);
  const [id, setSelectId] = useState([]);
  const [doctorId, setDoctorId] = useState();
  const [value, setDOB] = useState(new Date());
  const [selectedtype, setSelectedType] = useState([]);
  const [selectedSubscriptions, setSelectedSubscriptions] = useState([]);
  const [reportModal, setReportModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [calenderInvite, setCalenderInvite] = useState(true);
  const initialUsersRef = useRef(null);
  const shouldFetchRef = useRef(true);
  const [profileData, setProfileData] = useState();
  const [profileLoading, setProfileLoading] = useState(true);

  const itemsPerPage = 10;
  const gridApi = useRef(null);

  const initialSearchFields = {
    "Physician/Client Name": "",
    Email: "",
    "Phone Number": "",
    Id: "",
    "Doctor/Client Id": "",
    Role: "",
    "Doctor Expertise": "",
  };

  const columnSearchRef = useRef({ ...initialSearchFields });
  const [searchNonce, setSearchNonce] = useState(0);

  const handleClose = () => {
    setUpdateModal(false);
    getUsers();
  };

  const handleReportModalClose = () => setReportModal(false);

  const handleSearchUpdate = useCallback((updatedSearch) => {
    columnSearchRef.current = { ...columnSearchRef.current, ...updatedSearch };
    setCurrentPage(1);
    setSearchNonce((n) => n + 1);
  }, []);

  const handleResetSearch = () => {
    Object.keys(initialSearchFields).forEach((key) => {
      columnSearchRef.current[key] = "";
    });

    if (initialUsersRef.current) {
      shouldFetchRef.current = false;
      setAllUser(initialUsersRef.current.users);
      setTotalCount(initialUsersRef.current.total);
    }

    setCurrentPage(1);
    setSearchNonce((n) => n + 1);
  };

  const getColumnDefs = useCallback((screenWidth) => [
    {
      field: "Physician/Client Name",
      headerName: "Name",
      width: screenWidth <= 991 ? 140 : "auto",
      headerComponent: () => (
        <SearchHeader
          field="Physician/Client Name"
          fieldLabel="Name"
          columnSearchRef={columnSearchRef}
          onSearch={handleSearchUpdate}
          searchNonce={searchNonce}
        />
      )
    },
    {
      field: "Email",
      width: screenWidth <= 991 ? 140 : "auto",
      headerComponent: () => (
        <SearchHeader
          field="Email"
          fieldLabel="Email"
          columnSearchRef={columnSearchRef}
          onSearch={handleSearchUpdate}
          searchNonce={searchNonce}
        />
      )
    },
    {
      field: "Phone Number",
      width: screenWidth <= 991 ? 140 : "auto",
      headerComponent: () => (
        <SearchHeader
          field="Phone Number"
          fieldLabel="Phone"
          columnSearchRef={columnSearchRef}
          onSearch={handleSearchUpdate}
          searchNonce={searchNonce}
        />
      )
    },
    {
      field: "Id",
      width: 120,
      headerComponent: () => (
        <SearchHeader
          field="Id"
          fieldLabel="ID"
          columnSearchRef={columnSearchRef}
          onSearch={handleSearchUpdate}
          searchNonce={searchNonce}
        />
      )
    },
    {
      headerName: "Doctor/Client Id",
      field: "Doctor_ClientId",
      width: screenWidth <= 991 ? 140 : "auto",
      headerComponent: () => (
        <SearchHeader
          field="Doctor/Client Id"
          fieldLabel="Doctor/Client ID"
          columnSearchRef={columnSearchRef}
          onSearch={handleSearchUpdate}
          searchNonce={searchNonce}
        />
      )
    },
    {
      field: "Role",
      width: screenWidth <= 991 ? 80 : 100,
      headerComponent: () => (
        <SearchHeader
          field="Role"
          fieldLabel="Role"
          columnSearchRef={columnSearchRef}
          onSearch={handleSearchUpdate}
          searchNonce={searchNonce}
        />
      )
    },
    {
      headerName: "Doctor Expertise",
      field: "Doctor_expertise",
      width: screenWidth <= 991 ? 140 : "auto",
      headerComponent: () => (
        <SearchHeader
          field="Doctor Expertise"
          fieldLabel="Expertise"
          columnSearchRef={columnSearchRef}
          onSearch={handleSearchUpdate}
          searchNonce={searchNonce}
        />
      )
    },
    {
      field: "Action",
      width: screenWidth <= 991 ? 100 : 120,
      pinned: screenWidth <= 991 ? "right" : null,
      cellRendererFramework: (params) => (
        <div>
          <Button
            onClick={() =>
              Update(
                params.data.Doctor_ClientId,
                params.data.data.croppedAvatar,
                params.data.data
              )
            }
          >
            Update
          </Button>
        </div>
      ),
    },
    {
      field: "Active/Deactive",
      width: 140,
      valueGetter: (params) => {
        if (params.data.Role === "doctor") {
          return params.data.isActive ? "Active" : "Pending";
        }
        return "";
      },
      cellRendererFramework: (params) => (
        <div>
          {params.data.Role === "doctor" ? (
            <select
              onChange={(e) =>
                handleChangeactive(e, params.data.Doctor_ClientId)
              }
              defaultValue={params.data.isActive ? "Active" : "Pending"}
              className="form-control status-text"
            >
              <option value="Pending">Pending</option>
              <option value="Active">Active</option>
            </select>
          ) : null}
        </div>
      ),
    },
    {
      field: "createdAt",
      headerName: "Registration date",
      valueFormatter: (params) => {
        const { role, createdAt } = params.data.data || {};

        if (role === "doctor") {
          return formattedDate(createdAt);
        }

        return "";
      },
    },
    {
      field: "Notification",
      width: 110,
      cellRendererFramework: (params) => (
        <div>
          {params.data.Role === "doctor" ? (
            <input
              type="checkbox"
              defaultChecked={params.data.data?.doctorPersonalData?.isNotification}
              onChange={(e) =>
                handleNotifcation(params.data.Doctor_ClientId, e.target.checked)
              }
              className="notificationcheck"
            />
          ) : null}
        </div>
      ),
    },
  ], [handleSearchUpdate, searchNonce]);

  const [columnDefs, setColumnDefs] = useState(() => getColumnDefs(window.innerWidth));

  useEffect(() => {
    const handleResize = () => {
      setColumnDefs(getColumnDefs(window.innerWidth));
    };

    // Initial setting of column definitions
    setColumnDefs(getColumnDefs(window.innerWidth));

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [getColumnDefs]);

  const handleNotifcation = async (id, flag) => {
    const data = {
      isNotification: flag,
      doctorUserId: id,
    };
    const response = await adminNoticiation(data);
    toast.success(t(response.data.message));
    getUsers();
  };

  const userDetails = async (id) => {
    try {
      setProfileLoading(true);
      const response = await getUserProfile({ userId: id });
      if ([200, 201, 202].includes(response.status)) {
        setProfileData(response.data.profileDetails[0]);
        setDoctorId(response.data.profileDetails[0]._id);
        setDOB(
          response.data?.profileDetails[0]?.clientDOB ?
            moment(response.data?.profileDetails[0]?.clientDOB).toDate() : null
        );
      }
      if (response.data.statusCode === 401) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setProfileLoading(false);
    }
  };

  const handleChangeactive = async (e, id) => {
    try {
      let data = {
        isActive: e.target.value == "Active" ? true : false,
        doctorId: id,
      };

      const response = await adminUpdateStatus(data);
      if ([200, 201, 203].includes(response.status)) {
        toast.success(t(response.data.message));
        getUsers();
      } else {
        toast.error(t(response.data.msg));
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  const Update = (id, url, data) => {
    setUpdateId(id);
    setUpdateModal(true);
    userDetails(id);
    setuserdata(data);
    setCalenderInvite(data?.doctorPersonalData?.sendCalendarInvite);
    if (data.role === "doctor") {
      setSelectedValue(data?.consultation);
      setSelectId(data?.consultation.map((d) => d._id));
      setSelectedType(data?.doctorPersonalData?.patientsCategory.map((d) => ({
        eng: d,
        heb: d === "Children" ? "ילד.ה" : "מבוגר"
      })));
      setSelectedSubscriptions(data?.doctorPersonalData?.subscriptions);
    } else {
      setSelectedValue([]);
      setSelectId([]);
      setSelectedType([]);
      setSelectedSubscriptions([]);
    }
  };

  const defaultColDef = useMemo(() => ({
    sortable: true,
    filter: true,
    editable: true,
    resizable: true,
    floatingFilter: false,
    width: "auto",
  }), []);

  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  const getUsers = useCallback(async (page = 1, searchObj = columnSearchRef.current) => {
    setLoading(true);
    try {
      const data = {
        page,
        perPage: itemsPerPage,
        searchFields: {
          name: searchObj["Physician/Client Name"] || "",
          email: searchObj["Email"] || "",
          phone: searchObj["Phone Number"] || "",
          id: searchObj["Id"] || "",
          doctorClientId: searchObj["Doctor/Client Id"] || "",
          role: searchObj["Role"] || "",
          expertise: searchObj["Doctor Expertise"] || ""
        }
      };

      const response = await adminGetUsers(data);

      const formattedUsers = response.data.user.map((d) => ({
        "Physician/Client Name": `${d.first_name} ${d.last_name}`,
        Email: d.email,
        "Phone Number": d.phone,
        Id: d.id,
        Doctor_ClientId: d._id,
        data: d,
        Role: d.role,
        isActive: d?.doctorPersonalData?.isActive,
        Doctor_expertise:
          d?.consultation && d?.consultation.length !== 0
            ? d?.consultation.map((d2) => d2.heb)
            : null,
      }));

      setAllUser(formattedUsers);
      setTotalCount(response.data.totalCount);

      if (!initialUsersRef.current) {
        initialUsersRef.current = {
          users: formattedUsers,
          total: response.data.totalCount,
        };
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  }, [itemsPerPage]);

  useEffect(() => {
    if (!shouldFetchRef.current) {
      shouldFetchRef.current = true;
      return;
    }
    getUsers(currentPage);
  }, [currentPage, searchNonce, getUsers]);

  const onGridReady = useCallback((params) => {
    gridApi.current = params.api;
  }, []);

  const onExportClick = useCallback(() => {
    if (!gridApi.current) return;
    const formattedDateStr = moment().format("DD-MM-YYYY HH-mm-ss");
    gridApi.current.exportDataAsCsv({
      fileName: `user-export-${formattedDateStr}.csv`
    });
  }, []);

  const onExportAllClick = useCallback(async () => {
    try {
      const perPage = totalCount && totalCount > 0 ? totalCount : 1000000;

      const data = {
        page: 1,
        perPage,
        searchFields: {
          name: columnSearchRef.current["Physician/Client Name"] || "",
          email: columnSearchRef.current["Email"] || "",
          phone: columnSearchRef.current["Phone Number"] || "",
          id: columnSearchRef.current["Id"] || "",
          doctorClientId: columnSearchRef.current["Doctor/Client Id"] || "",
          role: columnSearchRef.current["Role"] || "",
          expertise: columnSearchRef.current["Doctor Expertise"] || ""
        }
      };

      const response = await adminGetUsers(data);

      const fullRows = (response.data.user || []).map((d) => ({
        "Physician/Client Name": `${d.first_name} ${d.last_name}`,
        Email: d.email,
        "Phone Number": d.phone,
        Id: d.id,
        Doctor_ClientId: d._id,
        data: d,
        Role: d.role,
        isActive: d?.doctorPersonalData?.isActive,
        Doctor_expertise:
          d?.consultation && d?.consultation.length
            ? d.consultation.map((c) => c.heb)
            : null,
      }));

      if (!gridApi.current) return;
      const api = gridApi.current;

      const prevData = allUser;
      api.setRowData(fullRows);

      api.exportDataAsCsv({
        fileName: `user-export-all-${moment().format("DD-MM-YYYY HH-mm-ss")}.csv`,
        allColumns: true
      });

      api.setRowData(prevData);
    } catch (err) {
      console.error(err);
      toast.error(t("Export failed"));
    }
  }, [totalCount, allUser, t]);

  return (
    <div className="user-mangement-page">
      <div className="container-fluid">
        {reportModal && <Report handleReportModalClose={handleReportModalClose} reportModal={reportModal} />}
        {updateModal && (
          <UpdateDetails
            userdata={userdata}
            updateId={updateId}
            updateModal={updateModal}
            selectedValue={selectedValue}
            id={id}
            doctorId={doctorId}
            value={value}
            setDOB={setDOB}
            setUpdateModal={setUpdateModal}
            setSelectedValue={setSelectedValue}
            setSelectId={setSelectId}
            handleClose={handleClose}
            selectedtype={selectedtype}
            selectedSubscriptions={selectedSubscriptions}
            setSelectedSubscriptions={setSelectedSubscriptions}
            setSelectedType={setSelectedType}
            setCalenderInvite={setCalenderInvite}
            calenderInvite={calenderInvite}
            connectedUsers={connectedUsers}
            setConnectedUsers={setConnectedUsers}
            setSelectDoctorId={setSelectDoctorId}
            selectedDoctorId={selectedDoctorId}
            setSelectSecretaryId={setSelectSecretaryId}
            selectedSecretaryId={selectedSecretaryId}
            profileData={profileData}
            profileLoading={profileLoading}
          />
        )}

        <div className="ag-theme-alpine" style={{ height: 630 }}>
          <div className="mb-2 d-flex flex-row align-items-center">
            <Button onClick={onExportClick} className="download_report">
              Export current page to CSV
            </Button>
            <Button onClick={onExportAllClick} className="download_report ms-2">
              Export all data to CSV
            </Button>
            <Button
              className="ms-2 me-auto"
              onClick={handleResetSearch}
            >
              Clear search
            </Button>
          </div>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ width: "100%", height: "100%" }}>
              <RotatingLines strokeColor="grey" strokeWidth="5" animationDuration="0.75" width="64" visible={true} />
            </div>
          ) : (
            <>
              <AgGridReact
                ref={gridRef}
                rowData={allUser}
                gridOptions={{ rowHeight: 60, groupHeaderHeight: 60, headerHeight: 60 }}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                rowSelection="multiple"
                onCellClicked={cellClickedListener}
                alwaysShowHorizontalScroll={true}
                alwaysShowVerticalScroll={true}
                onGridReady={onGridReady}
              />
              {(allUser.length) > 0 && (
                <div className="d-flex justify-content-center mt-3">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      const prevPage = Math.max(currentPage - 1, 1);
                      setCurrentPage(prevPage);
                    }}
                    disabled={currentPage === 1}
                    className="me-2"
                  >
                    הקודם
                  </Button>

                  <span style={{ lineHeight: "38px", margin: "0 16px" }}>
                    עמוד {currentPage} מתוך {Math.ceil(totalCount / itemsPerPage)}
                  </span>

                  <Button
                    variant="secondary"
                    onClick={() => {
                      const nextPage = currentPage + 1;
                      setCurrentPage(nextPage);
                    }}
                    disabled={currentPage === Math.ceil(totalCount / itemsPerPage)}
                    className="ms-2"
                  >
                    הבא
                  </Button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserTable;